import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import {useParams} from "react-router-dom";
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";

let initialValue = {
    products: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_PRODUCTS_DATA': {
            return {
                ...state,
                variations: action.payload,
            }
        }
        case 'ADD_VARIATION': {
            state.variations.products.push(action.payload.product);
            let newState = {
                products: state.variations.products
            }
            return {
                ...state,
                variations: newState,
            }
        }
        case 'UPDATE_STATUS': {
            let newData = state.variations.products.map((pro) =>
                action.payload.data.id === pro.id ? action.payload.data : pro
            );
            let newState = {
                products: newData
            }
            return {
                ...state,
                variations: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const ProductDetailContext = createContext({
    variations: initialValue,
    getProductDetail: () => {},
    addVariation: () => {},
    changeProductStatus: () => {},
})

export const ProductDetailProvider = ({settings, children}) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const {id} = useParams();

    const { setError } = useError();


    const getProductDetail = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.get('/api/products/get_all_product_detail/'+id, options);


            dispatch({
                type: 'LOAD_PRODUCTS_DATA',
                payload: res.data
            })

        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const addVariation = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/add_variation', data, options);


            dispatch({
                type: 'ADD_VARIATION',
                payload: res.data
            })
            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }


    const changeProductStatus = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_status/${product_id}/${status}`, options);

            dispatch({
                type: 'UPDATE_STATUS',
                payload: res.data
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    useEffect(() => {
        getProductDetail(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.variations === undefined) {
        return <MatxLoading />
    }

    return (
        <ProductDetailContext.Provider
            value={{
                variations: state.variations,
                getProductDetail,
                addVariation,
                changeProductStatus
            }}
        >
            {children}
        </ProductDetailContext.Provider>
    )
}

export default ProductDetailContext
